import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showApiErrorToast } from '@/utils/errors';
import { createPcmpProject, pcmpProjectQueryKeys } from '../api/pcmpProjects.api';
import type { PcmpProjectPayload, PcmpProjectRef } from '../types/pcmpProject.types';

export function useCreatePcmpProject(onSuccess: (project: PcmpProjectRef) => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpProjectPayload) => createPcmpProject(payload),
    onSuccess: (project) => {
      void queryClient.invalidateQueries({ queryKey: pcmpProjectQueryKeys.lists() });
      onSuccess(project);
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to create the project');
    },
  });
}
